<template>
  <b-card>

    <b-row>

      <!-- User Info: Left col -->
      <b-col
        cols="21"
        xl="6"
        class="d-flex justify-content-between flex-column"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="userData.user.avatar"
            :text="avatarText(userData.user.full_name)"
            :variant="`light-${resolveUserRoleVariant(userData.user.role.display_name)}`"
            size="104px"
            rounded
          />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ userData.user.full_name }}
              </h4>
            </div>
          </div>
        </div>

      </b-col>

      <!-- Right Col: Table -->
      <b-col
        cols="12"
        xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">ID</span>
            </th>
            <td class="pb-50">
              {{ userData.user.id }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="CheckIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Verified Shliach</span>
            </th>
            <td class="pb-50 text-capitalize">
              <b-badge variant="light-primary text-uppercase">
                {{ userData.is_shliach_member }}
              </b-badge>
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="StarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Gender</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.user.extra_user_info.gender }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon
                icon="GridIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Age</span>
            </th>
            <td>
              {{ userData.user.extra_user_info.age }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BAvatar, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import useUsersList from '@/views/apps/user/users-list/useUsersList'

export default {
  components: {
    BCard, BRow, BCol, BAvatar, BBadge,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { resolveUserRoleVariant } = useUsersList()
    return {
      avatarText,
      resolveUserRoleVariant,
    }
  },
}
</script>

<style>

</style>
